<script>
import { useI18n } from 'vue-i18n'
import Panel from '@/components/layout/Panel.vue'
import BarGraph from '@/components/ui/graphs/BarGraph.vue'
import { useAuthStore } from '@/stores/auth.js'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

export default {
    name: 'StatsSection',
    components: { Panel, BarGraph },
    setup() {
        const { t } = useI18n()
        const authStore = useAuthStore()
        const router = useRouter()

        const throwData = computed(() => {
            const stats = authStore.statistics
            if (!stats?.last_twenty_throws?.matchtype_501) {
                return []
            }
            return stats.last_twenty_throws.matchtype_501
        })

        const average = computed(() => {
            if (!throwData.value.length) return 0
            const avg = throwData.value.reduce((a, b) => a + b, 0) / throwData.value.length
            return Math.floor(avg * 100) / 100
        })

        const goToStatistics = () => {
            router.push({ name: 'statistics' })
        }

        return {
            throwData,
            average,
            goToStatistics,
            t,
        }
    },
}
</script>

<template>
    <Panel class="w-full">
        <div class="flex flex-col gap-6">
            <div class="flex items-center justify-between">
                <h2 class="flex flex-1">
                    {{ t('stats_section.avg_label', { n: throwData.length }) }}
                    <b v-if="average" class="ml-auto">{{ average }}</b>
                </h2>
            </div>
            <div @click="goToStatistics" class="cursor-pointer">
                <BarGraph
                    v-if="throwData.length > 0"
                    :data="throwData"
                    showAverage
                    :min="0"
                    :max="180"
                />
                <div v-else class="flex items-center justify-center">
                    <div class="px-6 py-8 text-center">
                        <div class="mb-3 text-4xl">🎯</div>
                        <div class="mb-2 text-lg font-bold text-white">{{ t('stats_section.no_throws') }}</div>
                        <div class="text-sm text-zinc-400">
                            {{ t('stats_section.no_throws_hint') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-end">
                <button
                    @click="goToStatistics"
                    data-testid="view-all-stats"
                    class="flex items-center justify-end text-left text-sm font-normal hover:text-red-500"
                >
                    <span>{{ t('stats_section.view_all') }}</span>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M5.5293 11.529L9.05794 8.00033L5.5293 4.47168L6.472 3.52897L10.9434 8.00033L6.472 12.4717L5.5293 11.529Z"
                            fill="#FF2C2C"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </Panel>
</template>
